import type {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'
import {SidebarLink} from '@/components/sidebar-link'
import {SidebarSection} from '@/components/sidebar-section'

function SidebarPhaseLabel({children}: {children: ReactNode}) {
  return (
    <div
      aria-hidden="true"
      className="sidenav-phase mt-3 mb-0.5 px-2.5 pl-3.5 font-mono text-[9px] font-semibold tracking-[0.12em] uppercase">
      {children}
    </div>
  )
}

/** Phases follow the Tabla de Valores of Res. 0312/2019 that the catalog carries. */
export function SidebarSgsst({
  businessId,
  planTrabajoLocked,
  custodiaSalud,
}: {
  businessId: string
  planTrabajoLocked: boolean
  custodiaSalud: boolean
}) {
  const {t} = useTranslation()
  return (
    <SidebarSection id="sgsst" context="tenant" label={t('nav.sectionSgsst')}>
      <SidebarLink to={`/businesses/${businessId}/sgsst`} end testId="nav-sgsst" title={t('nav.sgsstFullName')}>
        {t('nav.sgsstEvaluacion')}
      </SidebarLink>

      <SidebarPhaseLabel>{t('nav.fasePlanear')}</SidebarPhaseLabel>
      <SidebarLink to={`/businesses/${businessId}/sgsst/matriz-legal`} testId="nav-matriz-legal">
        {t('nav.sgsstMatrizLegal')}
      </SidebarLink>
      <SidebarLink to={`/businesses/${businessId}/plan-trabajo`} testId="nav-plan-trabajo" locked={planTrabajoLocked}>
        {t('nav.planTrabajo')}
      </SidebarLink>
      <SidebarLink to={`/businesses/${businessId}/sgsst/perfiles-cargo`} testId="nav-perfiles-cargo">
        {t('nav.perfilesCargo')}
      </SidebarLink>

      <SidebarPhaseLabel>{t('nav.faseHacer')}</SidebarPhaseLabel>
      <SidebarLink to={`/businesses/${businessId}/sgsst/matriz-riesgos`} testId="nav-matriz-riesgos">
        {t('ipevr.nav.title')}
      </SidebarLink>
      <SidebarLink to={`/businesses/${businessId}/bateria`} testId="nav-bateria">
        {t('nav.bateria')}
      </SidebarLink>
      <SidebarLink to={`/businesses/${businessId}/ips`} testId="nav-ips">
        {t('nav.ipsSolicitudes')}
      </SidebarLink>
      {/* Solo custodios (al dueño la API le da 403), siempre visible aunque §10 pide «solo si hay algo»:
          `GET /cuarentena` escribe en `acceso_salud` por persona listada y no se pide desde el sidebar. */}
      {custodiaSalud && (
        <SidebarLink to={`/businesses/${businessId}/cuarentena`} testId="nav-cuarentena">
          {t('nav.cuarentena')}
        </SidebarLink>
      )}
      <SidebarLink to={`/businesses/${businessId}/incidentes`} testId="nav-incidentes">
        {t('nav.incidentes')}
      </SidebarLink>

      <SidebarPhaseLabel>{t('nav.faseVerificar')}</SidebarPhaseLabel>
      <SidebarLink to={`/businesses/${businessId}/sgsst/indicadores`} testId="nav-indicadores">
        {t('nav.indicadores')}
      </SidebarLink>

      <SidebarPhaseLabel>{t('nav.faseActuar')}</SidebarPhaseLabel>
      <SidebarLink to={`/businesses/${businessId}/sgsst/plan`} testId="nav-plan-mejoramiento">
        {t('nav.sgsstPlan')}
      </SidebarLink>
      <SidebarLink to={`/businesses/${businessId}/sgsst/carpetas-visita`} testId="nav-carpetas-visita">
        {t('nav.carpetasVisita')}
      </SidebarLink>
    </SidebarSection>
  )
}
